const EOL = '\r\n'

const SPECIAL_CHARS = /["\r\n]/
const QUOTE_CHAR = /"/g

type CsvValue = string | number | null | undefined

const toText = (value: CsvValue): string => {
  if (value === null || value === undefined) {
    return ''
  }

  return `${value}`
}

const quoteIfRequired = (value: string, separator: string): string => {
  const needsQuotes = SPECIAL_CHARS.test(value) || value.includes(separator)

  return needsQuotes ? `"${value.replace(QUOTE_CHAR, '""')}"` : value
}

/**
 * Serializes one row of values into a CSV line, terminated by CRLF.
 *
 * A value is quoted when it holds the separator, a double quote or a line
 * break; quotes inside are doubled. This is the subset of the `csv-string`
 * behaviour the export actually relied on — the package itself pulled in the
 * whole Node stream polyfill through its unused `Streamer`. OCT-4846
 */
export const stringifyCsvRow = (
  values: CsvValue[],
  separator: string
): string => {
  return (
    values
      .map((value) => quoteIfRequired(toText(value), separator))
      .join(separator) + EOL
  )
}
